
<template>
    
        <mars-view class="article"><mars-view v-if="!searchTitle"><mars-view class="article-title">{{ law.title }}</mars-view><mars-view class="decs"><mars-text class="time">发布：{{ law.release_date }}实施：{{ law.effective_date }}</mars-text><mars-text v-if="law.timeliness_type !== '-1'" class="tag" :class="law.dynamicTag">{{ law.timeliness }}</mars-text></mars-view><mars-view v-if="remark" class="abstract"><mars-view class="abstract-title">法律修订</mars-view><mars-view class="abstract-desc">
                {{ remark }}
            </mars-view></mars-view></mars-view><mars-view v-if="rules.length > 0" class="law"><mars-view v-show="!searchTitle" class="law-text">
            正文
        </mars-view><mars-view v-for="(item, index) in rules" :id="'active-' + (item.index || 'search')" :key="index" :class="[{'law-seq': item.type === 'clause'},
                     {'law-section': item.type === 'section'},
                     {'law-search': item.data_type === 'searchCount'},
                     {'law-sheet': item.type === 'sheet'}]"><mars-view v-if="item.title" class="rule-title"><mars-rich-text :nodes="(getDynamicClass(item.title + (item.type !== 'clause' ? (' &nbsp;&nbsp;' + item.text) : '')))"></mars-rich-text></mars-view><mars-view v-if="(item.type === 'clause' || item.data_type === 'searchCount') && item.text" class="rule-text" :class="{'searchCount': item.data_type === 'searchCount'}"><mars-rich-text :nodes="(getDynamicClass((item.text)))"></mars-rich-text></mars-view></mars-view><mars-view v-if="searchTitle && contentCount" class="view-origin" @click.native="viewOriginclick"><mars-view><mars-text class="view-origin-text">查看全文</mars-text><mars-text class="icon view-more"></mars-text></mars-view></mars-view></mars-view><mars-view v-if="rules.length === 0" class="no-content">
        “抱歉，没有找到相关内容”
    </mars-view></mars-view>
    
</template>

<script>
/* globals swan getApp */

export default {
  props: {
    law: {
      type: Object,
      default() {
        return {};
      }
    },
    rules: {
      type: Array,
      default() {
        return [];
      }
    },
    remark: {
      type: String,
      default() {
        return '';
      }
    },
    searchTitle: {
      type: Object,
      default() {
        return null;
      }
    },
    contentCount: {
      type: Number,
      default() {
        return 0;
      }
    }
  },
  methods: {
    getDynamicClass(str = '') {
      return str.replace(/\<em\>/g, '<em class="dynamic">');
    },
    // 查看原文
    viewOriginclick() {
      this.$emit('viewOrigin');
    }
  }
};
</script>

<style scoped>
 /deep/ em {
  color: #f11;
  text-decoration: none;
  font-style: normal;
}
.dynamic {
  color: #f11;
  text-decoration: none;
  font-style: normal;
}
.article {
  font-family: Arial, Helvetica, sans-serif;
  padding: 0 17px;
  padding-bottom: 20px;
  background: #fff;
}
.article .article-title {
  font-size: 24px;
  color: #222;
  font-weight: 700;
  line-height: 36px;
}
.article .decs {
  margin-top: 2px;
  color: #999;
  vertical-align: middle;
}
.article .decs .time {
  margin-right: 6px;
  vertical-align: middle;
}
.article .decs .tag {
  border-radius: 8px;
  color: #39b362;
  background: rgba(57, 179, 98, 0.1);
  border: 1px solid rgba(57, 179, 98, 0.5);
  font-size: 10px;
  padding: 0 5px;
  white-space: nowrap;
  vertical-align: middle;
  line-height: 1.4;
  height: 1.5em;
  box-sizing: border-box;
  display: inline-block;
}
.article .decs .modified-valid {
  color: #3b92f1;
  background: rgba(59, 146, 241, 0.1);
  border: 1px solid rgba(59, 146, 241, 0.5);
}
.article .decs .amendment-valid {
  color: #4e6ef2;
  background: rgba(78, 110, 242, 0.1);
  border: 1px solid rgba(78, 110, 242, 0.5);
}
.article .decs .partial-invalid {
  color: #f7534f;
  background: rgba(247, 83, 79, 0.1);
  border: 1px solid rgba(247, 83, 79, 0.5);
}
.article .decs .invalid {
  color: #858585;
  background: rgba(133, 133, 133, 0.06);
  border: 1px solid rgba(133, 133, 133, 0.5);
}
.article .abstract {
  background: #f6f7f8;
  border-radius: 9px;
  padding: 21px  17px;
  line-height: 30px;
  margin-top: 20px;
}
.article .abstract .abstract-title {
  font-size: 19px;
  color: #222;
  font-weight: 700;
}
.article .abstract .abstract-desc {
  font-size: 19px;
  color: #555;
  letter-spacing: 0;
  line-height: 30px;
  margin-top: 6px;
}
.article .law {
  background: #fff;
}
.article .law .law-text {
  padding-top: 27px;
  font-size: 24px;
  color: #222;
  font-weight: 700;
}
.article .law .law-section {
  font-size: 24px;
  color: #222;
  padding-top: 25px;
  font-weight: 700;
}
.article .law .law-sheet {
  margin-top: 25px;
  font-size: 25px;
  margin-bottom: -14px;
}
.article .law .law-search {
  font-size: 19px;
  color: #555;
}
.article .law .law-seq {
  font-size: 18px;
  color: #555;
  font-weight: normal;
  padding-top: 11px;
  line-height: 30px;
}
.article .law .law-detail {
  margin-top: 14px;
}
.article .law .rule-title {
  font-weight: 700;
  color: #222;
}
.article .law .rule-text {
  margin-top: 5px;
  margin-bottom: 5px;
}
.article .law .searchCount {
  margin-top: 0;
}
.article .law .view-origin {
  padding-top: 13px;
  font-size: 16px;
  color: #445fbb;
  vertical-align: middle;
  display: flex;
  justify-content: flex-end;
}
.article .law .view-origin .view-origin-text {
  vertical-align: middle;
  margin-right: 3px;
}
.article .law .view-origin .view-more {
  background: #f5f5f5;
  border-radius: 50%;
  vertical-align: middle;
  width: 16px;
  height: 16px;
  display: inline-block;
  background: url('https://law-smartapp.cdn.bcebos.com/icon/icon-more.png');
  background-size: 100% 100%;
}
.article .no-content {
  font-family: Arial, Helvetica, sans-serif;
  color: #999;
  text-align: center;
  margin-top: -15px;
  padding: 20vw 0 20vw 0;
}

</style>
